import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const styles = (theme) => ({
  root: {},
  icon: {
    padding: 0,
    marginLeft: 5,
  },
  row: {
    backgroundColor: `${theme.palette.xpl.background}`,
  },
  expandedCell: {
    padding: '10px 15px',
    color: theme.palette.xpl.text.secondary,
    borderBottomColor: theme.palette.xpl.stoke,
  },
  cell: {
    padding: '18px 15px',
    color: theme.palette.xpl.text.secondary,
    lineHeight: '20px',
    borderBottomColor: theme.palette.xpl.stoke,
  },
  cellMobile: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
});

const TableExpandableRow = ({
  classes,
  metadata,
  row,
  expandableColumn,
  ...rest
}) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <>
      <TableRow {...rest} onClick={() => setIsExpanded(!isExpanded)}>
        {metadata.map((column, j) => {
          if (column.id === expandableColumn) {
            return (
              <TableCell
                key={j}
                align={column.alignment}
                className={classNames(classes.cell, column.className, {
                  [classes.cellMobile]: column.hideInMobile,
                })}>
                {row[column.renderingField]}
                <IconButton
                  className={classes.icon}
                  onClick={() => setIsExpanded(!isExpanded)}>
                  {isExpanded ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </IconButton>
              </TableCell>
            );
          }
          return (
            <TableCell
              key={j}
              align={column.alignment}
              className={classNames(classes.cell, column.className, {
                [classes.cellMobile]: column.hideInMobile,
              })}>
              {row[column.renderingField]}
            </TableCell>
          );
        })}
      </TableRow>
      {isExpanded && (
        <>
          {row.__childrens.map((row, i) => {
            return (
              <TableRow key={row.id} className={classes.row}>
                {metadata.map((column, j) => {
                  return (
                    <TableCell
                      key={j}
                      className={classNames(
                        classes.expandedCell,
                        column.className,
                        { [classes.cellMobile]: column.hideInMobile }
                      )}
                      align={column.alignment}>
                      {row[column.renderingField]}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </>
      )}
    </>
  );
};

TableExpandableRow.propTypes = {
  classes: PropTypes.object.isRequired,
  metadata: PropTypes.array.isRequired,
  row: PropTypes.object,
  expandableColumn: PropTypes.string,
};

export default withStyles(styles)(TableExpandableRow);
